import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseAddStaffUserMutationResponse } from "../utils/types";

const useAddStaff = (): IUseAddStaffUserMutationResponse =>
  useMutation({
    mutationFn: async (data) => {
      const response = await AXIOS_RESERVATION.post("v1/staff", data, {
        headers: {
          pageName: "staff",
        },
      });
      return response.data;
    },
  });

export default useAddStaff;
